export default __webpack_public_path__ + "static/media/WB_Arcade1.019f1a49.gif";